<template>
  <div class="main-content-container overflow-hidden">
    <PageTitle pageTitle="Data Port" subTitle="Forms" />

    <ListPort />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/Common/PageTitle.vue";
import ListPort from "@/components/Pages/Master/Port/ListPort.vue";

export default defineComponent({
  name: "ListPortPage",
  components: {
    PageTitle,
    ListPort,
  },
});
</script>
